import { RouteIcons } from "../types";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import {
  GroupAdd as GroupAddIcon,
  EditAttributes as EditAttributesIcon,
  Schema as SchemaIcon,
  SettingsApplications as SettingsApplicationsIcon,
  CastConnected as CastConnectedIcon,
  Description as DescriptionIcon,
} from "@mui/icons-material";

export const SettingsIcon = ({ small }: { small?: boolean }) => {
  return (
    <svg width={small ? "22" : "26"} height={small ? "22" : "26"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.60417 3.5975C8.95917 2.13417 11.0408 2.13417 11.3958 3.5975C11.4491 3.81733 11.5535 4.02148 11.7006 4.19333C11.8477 4.36518 12.0332 4.49988 12.2422 4.58645C12.4512 4.67303 12.6776 4.70904 12.9032 4.69156C13.1287 4.67407 13.3469 4.60359 13.54 4.48583C14.8258 3.7025 16.2983 5.17417 15.515 6.46083C15.3974 6.65388 15.327 6.87195 15.3096 7.09731C15.2922 7.32267 15.3281 7.54897 15.4146 7.75782C15.5011 7.96666 15.6356 8.15215 15.8073 8.29921C15.9789 8.44627 16.1829 8.55075 16.4025 8.60417C17.8658 8.95917 17.8658 11.0408 16.4025 11.3958C16.1827 11.4491 15.9785 11.5535 15.8067 11.7006C15.6348 11.8477 15.5001 12.0332 15.4135 12.2422C15.327 12.4512 15.291 12.6776 15.3084 12.9032C15.3259 13.1287 15.3964 13.3469 15.5142 13.54C16.2975 14.8258 14.8258 16.2983 13.5392 15.515C13.3461 15.3974 13.1281 15.327 12.9027 15.3096C12.6773 15.2922 12.451 15.3281 12.2422 15.4146C12.0333 15.5011 11.8479 15.6356 11.7008 15.8073C11.5537 15.9789 11.4492 16.1829 11.3958 16.4025C11.0408 17.8658 8.95917 17.8658 8.60417 16.4025C8.5509 16.1827 8.44648 15.9785 8.29941 15.8067C8.15233 15.6348 7.96676 15.5001 7.75779 15.4135C7.54882 15.327 7.32236 15.291 7.09685 15.3084C6.87133 15.3259 6.65313 15.3964 6.46 15.5142C5.17417 16.2975 3.70167 14.8258 4.485 13.5392C4.60258 13.3461 4.67296 13.1281 4.6904 12.9027C4.70785 12.6773 4.67187 12.451 4.58539 12.2422C4.49892 12.0333 4.36438 11.8479 4.19273 11.7008C4.02107 11.5537 3.81714 11.4492 3.5975 11.3958C2.13417 11.0408 2.13417 8.95917 3.5975 8.60417C3.81733 8.5509 4.02148 8.44648 4.19333 8.29941C4.36518 8.15233 4.49988 7.96676 4.58645 7.75779C4.67303 7.54882 4.70904 7.32236 4.69156 7.09685C4.67407 6.87133 4.60359 6.65313 4.48583 6.46C3.7025 5.17417 5.17417 3.70167 6.46083 4.485C7.29417 4.99167 8.37417 4.54333 8.60417 3.5975Z"
        stroke="white"
        stroke-opacity="0.8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 10C7.5 10.663 7.76339 11.2989 8.23223 11.7678C8.70107 12.2366 9.33696 12.5 10 12.5C10.663 12.5 11.2989 12.2366 11.7678 11.7678C12.2366 11.2989 12.5 10.663 12.5 10C12.5 9.33696 12.2366 8.70107 11.7678 8.23223C11.2989 7.76339 10.663 7.5 10 7.5C9.33696 7.5 8.70107 7.76339 8.23223 8.23223C7.76339 8.70107 7.5 9.33696 7.5 10Z"
        stroke="white"
        stroke-opacity="0.8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const DashboardIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.33203 3.3335H8.33203V10.0002H3.33203V3.3335Z" stroke="white" stroke-opacity="0.8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M3.33203 13.3335H8.33203V16.6668H3.33203V13.3335Z" stroke="white" stroke-opacity="0.8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.6654 10.0002H16.6654V16.6668H11.6654V10.0002Z" stroke="white" stroke-opacity="0.8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.6654 3.3335H16.6654V6.66683H11.6654V3.3335Z" stroke="white" stroke-opacity="0.8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};
const CustomerIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 17.5V15.8333C2.5 14.9493 2.85119 14.1014 3.47631 13.4763C4.10143 12.8512 4.94928 12.5 5.83333 12.5H9.16667C10.0507 12.5 10.8986 12.8512 11.5237 13.4763C12.1488 14.1014 12.5 14.9493 12.5 15.8333V17.5M13.3333 2.60834C14.0503 2.79192 14.6859 3.20892 15.1397 3.7936C15.5935 4.37827 15.8399 5.09736 15.8399 5.8375C15.8399 6.57765 15.5935 7.29674 15.1397 7.88141C14.6859 8.46609 14.0503 8.88309 13.3333 9.06667M17.5 17.5V15.8334C17.4958 15.0977 17.2483 14.384 16.7961 13.8037C16.3439 13.2234 15.7124 12.8089 15 12.625M4.16667 5.83333C4.16667 6.71739 4.51786 7.56524 5.14298 8.19036C5.7681 8.81548 6.61594 9.16667 7.5 9.16667C8.38405 9.16667 9.2319 8.81548 9.85702 8.19036C10.4821 7.56524 10.8333 6.71739 10.8333 5.83333C10.8333 4.94928 10.4821 4.10143 9.85702 3.47631C9.2319 2.85119 8.38405 2.5 7.5 2.5C6.61594 2.5 5.7681 2.85119 5.14298 3.47631C4.51786 4.10143 4.16667 4.94928 4.16667 5.83333Z"
        stroke="white"
        stroke-opacity="0.8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ProjectsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16667 15.8333L6.46417 9.70742C6.5237 9.54861 6.63027 9.41174 6.76964 9.3151C6.90902 9.21846 7.07456 9.16665 7.24417 9.16659H17.5M4.16667 15.8333H15.855C16.2427 15.8331 16.6183 15.6979 16.917 15.4507C17.2158 15.2035 17.419 14.8599 17.4917 14.4791L18.3217 10.1366C18.3415 10.0173 18.3351 9.89504 18.303 9.77842C18.2708 9.66181 18.2137 9.55359 18.1355 9.46129C18.0573 9.36899 17.96 9.29482 17.8502 9.24392C17.7405 9.19303 17.621 9.16664 17.5 9.16659M4.16667 15.8333C3.72464 15.8333 3.30072 15.6577 2.98816 15.3451C2.67559 15.0325 2.5 14.6086 2.5 14.1666V4.99992C2.5 4.55789 2.67559 4.13397 2.98816 3.82141C3.30072 3.50885 3.72464 3.33325 4.16667 3.33325H7.5L10 5.83325H15.8333C16.2754 5.83325 16.6993 6.00885 17.0118 6.32141C17.3244 6.63397 17.5 7.05789 17.5 7.49992V9.16659"
        stroke="white"
        stroke-opacity="0.8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const OperationsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4167 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V10.4167M2.5 8.33333H17.5M8.33333 2.5V17.5M13.3333 15.8333H18.3333M15.8333 13.3333V18.3333"
        stroke="white"
        stroke-opacity="0.8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const EnterpriseSolutionsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 17.5V15.8333C5 14.9493 5.35119 14.1014 5.97631 13.4763C6.60143 12.8512 7.44928 12.5 8.33333 12.5H10.4167M15.8341 17.5C15.3921 17.5 14.9682 17.3244 14.6556 17.0118C14.3431 16.6993 14.1675 16.2754 14.1675 15.8333C14.1675 15.3913 14.3431 14.9674 14.6556 14.6548C14.9682 14.3423 15.3921 14.1667 15.8341 14.1667M15.8341 17.5C16.2762 17.5 16.7001 17.3244 17.0127 17.0118C17.3252 16.6993 17.5008 16.2754 17.5008 15.8333C17.5008 15.3913 17.3252 14.9674 17.0127 14.6548C16.7001 14.3423 16.2762 14.1667 15.8341 14.1667M15.8341 17.5V18.75M15.8341 14.1667V12.9167M18.3599 14.375L17.2774 15M14.3916 16.6667L13.3083 17.2917M13.3083 14.375L14.3916 15M17.2774 16.6667L18.3608 17.2917M6.66667 5.83333C6.66667 6.71739 7.01786 7.56523 7.64298 8.19036C8.2681 8.81548 9.11595 9.16667 10 9.16667C10.8841 9.16667 11.7319 8.81548 12.357 8.19036C12.9821 7.56523 13.3333 6.71739 13.3333 5.83333C13.3333 4.94928 12.9821 4.10143 12.357 3.47631C11.7319 2.85119 10.8841 2.5 10 2.5C9.11595 2.5 8.2681 2.85119 7.64298 3.47631C7.01786 4.10143 6.66667 4.94928 6.66667 5.83333Z"
        stroke="white"
        stroke-opacity="0.8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const TechsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 8.33333H4.16667M2.5 11.6667H4.16667M8.33333 2.5V4.16667M11.6667 2.5V4.16667M17.5 8.33333H15.8333M17.5 11.6667H15.8333M11.6667 17.5V15.8333M8.33333 17.5V15.8333M4.16667 5C4.16667 4.77899 4.25446 4.56702 4.41074 4.41074C4.56702 4.25446 4.77899 4.16667 5 4.16667H15C15.221 4.16667 15.433 4.25446 15.5893 4.41074C15.7455 4.56702 15.8333 4.77899 15.8333 5V15C15.8333 15.221 15.7455 15.433 15.5893 15.5893C15.433 15.7455 15.221 15.8333 15 15.8333H5C4.77899 15.8333 4.56702 15.7455 4.41074 15.5893C4.25446 15.433 4.16667 15.221 4.16667 15V5ZM7.5 7.5H12.5V12.5H7.5V7.5Z"
        stroke="white"
        stroke-opacity="0.8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const SalesIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5013 4.16667H5.83464C5.39261 4.16667 4.96868 4.34226 4.65612 4.65482C4.34356 4.96738 4.16797 5.39131 4.16797 5.83333V15.8333C4.16797 16.2754 4.34356 16.6993 4.65612 17.0118C4.96868 17.3244 5.39261 17.5 5.83464 17.5H14.168C14.61 17.5 15.0339 17.3244 15.3465 17.0118C15.659 16.6993 15.8346 16.2754 15.8346 15.8333V5.83333C15.8346 5.39131 15.659 4.96738 15.3465 4.65482C15.0339 4.34226 14.61 4.16667 14.168 4.16667H12.5013M7.5013 4.16667C7.5013 3.72464 7.6769 3.30072 7.98946 2.98816C8.30202 2.67559 8.72594 2.5 9.16797 2.5H10.8346C11.2767 2.5 11.7006 2.67559 12.0131 2.98816C12.3257 3.30072 12.5013 3.72464 12.5013 4.16667M7.5013 4.16667C7.5013 4.60869 7.6769 5.03262 7.98946 5.34518C8.30202 5.65774 8.72594 5.83333 9.16797 5.83333H10.8346C11.2767 5.83333 11.7006 5.65774 12.0131 5.34518C12.3257 5.03262 12.5013 4.60869 12.5013 4.16667M11.668 9.16667H9.58464C9.25312 9.16667 8.93517 9.29836 8.70075 9.53278C8.46633 9.7672 8.33464 10.0851 8.33464 10.4167C8.33464 10.7482 8.46633 11.0661 8.70075 11.3006C8.93517 11.535 9.25312 11.6667 9.58464 11.6667H10.418C10.7495 11.6667 11.0674 11.7984 11.3019 12.0328C11.5363 12.2672 11.668 12.5851 11.668 12.9167C11.668 13.2482 11.5363 13.5661 11.3019 13.8005C11.0674 14.035 10.7495 14.1667 10.418 14.1667H8.33464M10.0013 14.1667V15M10.0013 8.33333V9.16667"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const FinanceIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 17.5H17.5M2.5 8.33333H17.5M4.16667 5L10 2.5L15.8333 5M3.33333 8.33333V17.5M16.6667 8.33333V17.5M6.66667 11.6667V14.1667M10 11.6667V14.1667M13.3333 11.6667V14.1667"
        stroke="white"
        stroke-opacity="0.8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ReportsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5013 4.16667H5.83464C5.39261 4.16667 4.96868 4.34226 4.65612 4.65482C4.34356 4.96738 4.16797 5.39131 4.16797 5.83333V15.8333C4.16797 16.2754 4.34356 16.6993 4.65612 17.0118C4.96868 17.3244 5.39261 17.5 5.83464 17.5H14.168C14.61 17.5 15.0339 17.3244 15.3465 17.0118C15.659 16.6993 15.8346 16.2754 15.8346 15.8333V5.83333C15.8346 5.39131 15.659 4.96738 15.3465 4.65482C15.0339 4.34226 14.61 4.16667 14.168 4.16667H12.5013M7.5013 4.16667C7.5013 3.72464 7.6769 3.30072 7.98946 2.98816C8.30202 2.67559 8.72594 2.5 9.16797 2.5H10.8346C11.2767 2.5 11.7006 2.67559 12.0131 2.98816C12.3257 3.30072 12.5013 3.72464 12.5013 4.16667M7.5013 4.16667C7.5013 4.60869 7.6769 5.03262 7.98946 5.34518C8.30202 5.65774 8.72594 5.83333 9.16797 5.83333H10.8346C11.2767 5.83333 11.7006 5.65774 12.0131 5.34518C12.3257 5.03262 12.5013 4.60869 12.5013 4.16667M7.5013 14.1667V10M10.0013 14.1667V13.3333M12.5013 14.1667V11.6667"
        stroke="white"
        stroke-opacity="0.8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const WarehouseSettingsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 17.4999V6.66659L10 3.33325L17.5 6.66659V17.4999M10.8333 10.8333H14.1667V17.4999H5.83333V12.4999H10.8333M10.8333 17.4999V9.99992C10.8333 9.77891 10.7455 9.56694 10.5893 9.41066C10.433 9.25438 10.221 9.16659 10 9.16659H8.33333C8.11232 9.16659 7.90036 9.25438 7.74408 9.41066C7.5878 9.56694 7.5 9.77891 7.5 9.99992V12.4999"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const CategoriesIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.6693 3.33325H16.6693V8.33325H11.6693V3.33325Z" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M3.33594 11.6666H8.33594V16.6666H3.33594V11.6666Z" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M11.6693 14.1666C11.6693 14.8296 11.9327 15.4655 12.4015 15.9344C12.8703 16.4032 13.5062 16.6666 14.1693 16.6666C14.8323 16.6666 15.4682 16.4032 15.937 15.9344C16.4059 15.4655 16.6693 14.8296 16.6693 14.1666C16.6693 13.5035 16.4059 12.8677 15.937 12.3988C15.4682 11.93 14.8323 11.6666 14.1693 11.6666C13.5062 11.6666 12.8703 11.93 12.4015 12.3988C11.9327 12.8677 11.6693 13.5035 11.6693 14.1666Z"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33594 5.83325C3.33594 6.16156 3.4006 6.48665 3.52624 6.78996C3.65188 7.09327 3.83602 7.36887 4.06817 7.60102C4.30032 7.83317 4.57591 8.01731 4.87923 8.14295C5.18254 8.26859 5.50763 8.33325 5.83594 8.33325C6.16424 8.33325 6.48933 8.26859 6.79265 8.14295C7.09596 8.01731 7.37156 7.83317 7.6037 7.60102C7.83585 7.36887 8.02 7.09327 8.14564 6.78996C8.27127 6.48665 8.33594 6.16156 8.33594 5.83325C8.33594 5.50495 8.27127 5.17986 8.14564 4.87654C8.02 4.57323 7.83585 4.29763 7.6037 4.06549C7.37156 3.83334 7.09596 3.64919 6.79265 3.52355C6.48933 3.39792 6.16424 3.33325 5.83594 3.33325C5.50763 3.33325 5.18254 3.39792 4.87923 3.52355C4.57591 3.64919 4.30032 3.83334 4.06817 4.06549C3.83602 4.29763 3.65188 4.57323 3.52624 4.87654C3.4006 5.17986 3.33594 5.50495 3.33594 5.83325Z"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const NotificationIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 14.1667V15C7.5 15.663 7.76339 16.2989 8.23223 16.7678C8.70107 17.2366 9.33696 17.5 10 17.5C10.663 17.5 11.2989 17.2366 11.7678 16.7678C12.2366 16.2989 12.5 15.663 12.5 15V14.1667M17.5009 5.60583C16.9542 4.41688 16.1605 3.35808 15.1725 2.5M2.5 5.60583C3.04612 4.41703 3.83929 3.35825 4.82667 2.5M8.33333 4.16667C8.33333 3.72464 8.50893 3.30072 8.82149 2.98816C9.13405 2.67559 9.55797 2.5 10 2.5C10.442 2.5 10.866 2.67559 11.1785 2.98816C11.4911 3.30072 11.6667 3.72464 11.6667 4.16667C12.6237 4.61919 13.4395 5.32361 14.0267 6.20442C14.6139 7.08523 14.9504 8.10923 15 9.16667V11.6667C15.0627 12.1848 15.2462 12.6809 15.5357 13.1151C15.8252 13.5493 16.2126 13.9095 16.6667 14.1667H3.33333C3.78745 13.9095 4.17484 13.5493 4.46432 13.1151C4.7538 12.6809 4.93729 12.1848 5 11.6667V9.16667C5.04963 8.10923 5.38608 7.08523 5.97329 6.20442C6.5605 5.32361 7.37633 4.61919 8.33333 4.16667Z"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const CommodityIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8333 6.66659C16.2754 6.66659 16.6993 6.49099 17.0118 6.17843C17.3244 5.86587 17.5 5.44195 17.5 4.99992C17.5 4.55789 17.3244 4.13397 17.0118 3.82141C16.6993 3.50885 16.2754 3.33325 15.8333 3.33325H4.16667C3.72464 3.33325 3.30072 3.50885 2.98816 3.82141C2.67559 4.13397 2.5 4.55789 2.5 4.99992C2.5 5.44195 2.67559 5.86587 2.98816 6.17843C3.30072 6.49099 3.72464 6.66659 4.16667 6.66659M15.8333 6.66659H4.16667M15.8333 6.66659V14.9999C15.8333 15.4419 15.6577 15.8659 15.3452 16.1784C15.0326 16.491 14.6087 16.6666 14.1667 16.6666H5.83333C5.39131 16.6666 4.96738 16.491 4.65482 16.1784C4.34226 15.8659 4.16667 15.4419 4.16667 14.9999V6.66659M8.33333 9.99992H11.6667"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ServicesIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.4974 5H16.6641M7.4974 10H16.6641M7.4974 15H16.6641M4.16406 5V5.00833M4.16406 10V10.0083M4.16406 15V15.0083"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ManufacturersIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5625 5.22498C16.8489 5.38787 17.0867 5.62413 17.2515 5.90945C17.4163 6.19477 17.5021 6.51884 17.5 6.84832V12.9183C17.5 13.5925 17.1308 14.2142 16.535 14.5417L10.91 18.1C10.6311 18.2531 10.3181 18.3334 10 18.3334C9.68186 18.3334 9.36887 18.2531 9.09 18.1L3.465 14.5417C3.17347 14.3823 2.9301 14.1476 2.76034 13.862C2.59058 13.5765 2.50067 13.2505 2.5 12.9183V6.84748C2.5 6.17332 2.86917 5.55248 3.465 5.22498L9.09 1.90832C9.37711 1.75001 9.69964 1.66699 10.0275 1.66699C10.3554 1.66699 10.6779 1.75001 10.965 1.90832L16.59 5.22498H16.5625Z"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.9167 7.85158C13.1767 8.00158 13.3358 8.28074 13.3333 8.58158V11.3124C13.3333 11.6157 13.1692 11.8957 12.9042 12.0432L10.4042 13.6449C10.2805 13.7135 10.1414 13.7495 10 13.7495C9.85859 13.7495 9.7195 13.7135 9.59583 13.6449L7.09583 12.0432C6.9656 11.971 6.85709 11.8652 6.78162 11.7368C6.70614 11.6084 6.66645 11.4622 6.66667 11.3132V8.58158C6.66667 8.27824 6.83083 7.99824 7.095 7.85074L9.595 6.35908C9.85417 6.21408 10.17 6.21408 10.4283 6.35908L12.9283 7.85074H12.9167V7.85158Z"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ProjectTypesIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0026 2.5L6.66927 8.33333H13.3359L10.0026 2.5Z" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M11.6693 14.1667C11.6693 14.8297 11.9327 15.4656 12.4015 15.9344C12.8703 16.4033 13.5062 16.6667 14.1693 16.6667C14.8323 16.6667 15.4682 16.4033 15.937 15.9344C16.4059 15.4656 16.6693 14.8297 16.6693 14.1667C16.6693 13.5036 16.4059 12.8677 15.937 12.3989C15.4682 11.9301 14.8323 11.6667 14.1693 11.6667C13.5062 11.6667 12.8703 11.9301 12.4015 12.3989C11.9327 12.8677 11.6693 13.5036 11.6693 14.1667Z"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33594 12.5C3.33594 12.279 3.42374 12.067 3.58002 11.9107C3.7363 11.7545 3.94826 11.6667 4.16927 11.6667H7.5026C7.72362 11.6667 7.93558 11.7545 8.09186 11.9107C8.24814 12.067 8.33594 12.279 8.33594 12.5V15.8333C8.33594 16.0543 8.24814 16.2663 8.09186 16.4226C7.93558 16.5789 7.72362 16.6667 7.5026 16.6667H4.16927C3.94826 16.6667 3.7363 16.5789 3.58002 16.4226C3.42374 16.2663 3.33594 16.0543 3.33594 15.8333V12.5Z"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const VendorTypesIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 17.5H17.5M2.5 5.83333V6.66667C2.5 7.32971 2.76339 7.96559 3.23223 8.43443C3.70107 8.90327 4.33696 9.16667 5 9.16667C5.66304 9.16667 6.29893 8.90327 6.76777 8.43443C7.23661 7.96559 7.5 7.32971 7.5 6.66667M2.5 5.83333H17.5M2.5 5.83333L4.16667 2.5H15.8333L17.5 5.83333M7.5 6.66667V5.83333M7.5 6.66667C7.5 7.32971 7.76339 7.96559 8.23223 8.43443C8.70107 8.90327 9.33696 9.16667 10 9.16667C10.663 9.16667 11.2989 8.90327 11.7678 8.43443C12.2366 7.96559 12.5 7.32971 12.5 6.66667M12.5 6.66667V5.83333M12.5 6.66667C12.5 7.32971 12.7634 7.96559 13.2322 8.43443C13.7011 8.90327 14.337 9.16667 15 9.16667C15.663 9.16667 16.2989 8.90327 16.7678 8.43443C17.2366 7.96559 17.5 7.32971 17.5 6.66667V5.83333M4.16667 17.5001V9.04175M15.8333 17.5001V9.04175M7.5 17.5V14.1667C7.5 13.7246 7.67559 13.3007 7.98816 12.9882C8.30072 12.6756 8.72464 12.5 9.16667 12.5H10.8333C11.2754 12.5 11.6993 12.6756 12.0118 12.9882C12.3244 13.3007 12.5 13.7246 12.5 14.1667V17.5"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const R2GradingOptionsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6693 3.33325V6.66659H6.66927V3.33325M5.0026 3.33325H13.3359L16.6693 6.66659V14.9999C16.6693 15.4419 16.4937 15.8659 16.1811 16.1784C15.8686 16.491 15.4446 16.6666 15.0026 16.6666H5.0026C4.56058 16.6666 4.13665 16.491 3.82409 16.1784C3.51153 15.8659 3.33594 15.4419 3.33594 14.9999V4.99992C3.33594 4.55789 3.51153 4.13397 3.82409 3.82141C4.13665 3.50885 4.56058 3.33325 5.0026 3.33325ZM8.33594 11.6666C8.33594 12.1086 8.51153 12.5325 8.82409 12.8451C9.13665 13.1577 9.56058 13.3333 10.0026 13.3333C10.4446 13.3333 10.8686 13.1577 11.1811 12.8451C11.4937 12.5325 11.6693 12.1086 11.6693 11.6666C11.6693 11.2246 11.4937 10.8006 11.1811 10.4881C10.8686 10.1755 10.4446 9.99992 10.0026 9.99992C9.56058 9.99992 9.13665 10.1755 8.82409 10.4881C8.51153 10.8006 8.33594 11.2246 8.33594 11.6666Z"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const CertificateTemplatesIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6667 2.5V5.83333C11.6667 6.05435 11.7545 6.26631 11.9107 6.42259C12.067 6.57887 12.279 6.66667 12.5 6.66667H15.8333M11.6667 2.5H5.83333C5.39131 2.5 4.96738 2.67559 4.65482 2.98816C4.34226 3.30072 4.16667 3.72464 4.16667 4.16667V6.66667M11.6667 2.5L15.8333 6.66667M15.8333 6.66667V15.8333C15.8333 16.2754 15.6577 16.6993 15.3452 17.0118C15.0326 17.3244 14.6087 17.5 14.1667 17.5H10M3.75 14.1667L2.5 18.3333L5 17.0833L7.5 18.3333L6.25 14.1667M2.5 11.6667C2.5 12.3297 2.76339 12.9656 3.23223 13.4344C3.70107 13.9033 4.33696 14.1667 5 14.1667C5.66304 14.1667 6.29893 13.9033 6.76777 13.4344C7.23661 12.9656 7.5 12.3297 7.5 11.6667C7.5 11.0036 7.23661 10.3677 6.76777 9.8989C6.29893 9.43006 5.66304 9.16667 5 9.16667C4.33696 9.16667 3.70107 9.43006 3.23223 9.8989C2.76339 10.3677 2.5 11.0036 2.5 11.6667Z"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const PricingTemplatesIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6641 2.5V5.83333C11.6641 6.05435 11.7519 6.26631 11.9081 6.42259C12.0644 6.57887 12.2764 6.66667 12.4974 6.66667H15.8307M11.6641 2.5H5.83073C5.3887 2.5 4.96478 2.67559 4.65222 2.98816C4.33966 3.30072 4.16406 3.72464 4.16406 4.16667V15.8333C4.16406 16.2754 4.33966 16.6993 4.65222 17.0118C4.96478 17.3244 5.3887 17.5 5.83073 17.5H14.1641C14.6061 17.5 15.03 17.3244 15.3426 17.0118C15.6551 16.6993 15.8307 16.2754 15.8307 15.8333V6.66667M11.6641 2.5L15.8307 6.66667M11.6641 9.16667H9.58073C9.24921 9.16667 8.93127 9.29836 8.69685 9.53278C8.46243 9.7672 8.33073 10.0851 8.33073 10.4167C8.33073 10.7482 8.46243 11.0661 8.69685 11.3006C8.93127 11.535 9.24921 11.6667 9.58073 11.6667H10.4141C10.7456 11.6667 11.0635 11.7984 11.2979 12.0328C11.5324 12.2672 11.6641 12.5851 11.6641 12.9167C11.6641 13.2482 11.5324 13.5661 11.2979 13.8005C11.0635 14.035 10.7456 14.1667 10.4141 14.1667H8.33073M9.9974 14.1667V15M9.9974 8.33333V9.16667"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const PrinterSettingsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1667 14.1667H15.8333C16.2754 14.1667 16.6993 13.9911 17.0118 13.6785C17.3244 13.366 17.5 12.942 17.5 12.5V9.16667C17.5 8.72464 17.3244 8.30072 17.0118 7.98816C16.6993 7.67559 16.2754 7.5 15.8333 7.5H4.16667C3.72464 7.5 3.30072 7.67559 2.98816 7.98816C2.67559 8.30072 2.5 8.72464 2.5 9.16667V12.5C2.5 12.942 2.67559 13.366 2.98816 13.6785C3.30072 13.9911 3.72464 14.1667 4.16667 14.1667H5.83333M14.1667 7.5V4.16667C14.1667 3.72464 13.9911 3.30072 13.6785 2.98816C13.366 2.67559 12.942 2.5 12.5 2.5H7.5C7.05797 2.5 6.63405 2.67559 6.32149 2.98816C6.00893 3.30072 5.83333 3.72464 5.83333 4.16667V7.5M5.83333 12.5C5.83333 12.058 6.00893 11.634 6.32149 11.3215C6.63405 11.0089 7.05797 10.8333 7.5 10.8333H12.5C12.942 10.8333 13.366 11.0089 13.6785 11.3215C13.9911 11.634 14.1667 12.058 14.1667 12.5V15.8333C14.1667 16.2754 13.9911 16.6993 13.6785 17.0118C13.366 17.3244 12.942 17.5 12.5 17.5H7.5C7.05797 17.5 6.63405 17.3244 6.32149 17.0118C6.00893 16.6993 5.83333 16.2754 5.83333 15.8333V12.5Z"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const rightArrowIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 5L12.5 10L7.5 15" stroke="white" stroke-opacity="0.8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

const upArrowIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 12.5L10 7.5L15 12.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

const routeIcons: RouteIcons = {
  workspaces: WorkspacesIcon,
  adminSettings: AdminPanelSettingsIcon,

  // main sidebar
  dashboard: DashboardIcon,
  customers: CustomerIcon,
  projects: ProjectsIcon,
  operations: OperationsIcon,
  enterpriseSolutions: EnterpriseSolutionsIcon,
  techs: TechsIcon,
  sales: SalesIcon,
  finance: FinanceIcon,
  reports: ReportsIcon,

  // system settings - global
  warehouseSettings: WarehouseSettingsIcon,
  category: CategoriesIcon,
  notification: NotificationIcon,
  commodity: CommodityIcon,
  services: ServicesIcon,
  manufacturers: ManufacturersIcon,
  projectTypes: ProjectTypesIcon,
  vendorTypes: VendorTypesIcon,
  r2GradingOptions: R2GradingOptionsIcon,
  certificateTemplates: CertificateTemplatesIcon,
  pricingTemplates: PricingTemplatesIcon,
  printerSettings: PrinterSettingsIcon,

  // system settings - admin
  usersAndRoles: GroupAddIcon,
  inventoryAttributes: EditAttributesIcon,
  assetWorkflow: SchemaIcon,
  integrations: CastConnectedIcon,
  generalSettings: SettingsApplicationsIcon,
  logs: DescriptionIcon,

  // other
  right: rightArrowIcon,
  up: upArrowIcon,
};

export default routeIcons;
